import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=3b0cc6e2&scoped=true"
import script from "./TagsList.vue?vue&type=script&lang=js"
export * from "./TagsList.vue?vue&type=script&lang=js"
import style0 from "./TagsList.vue?vue&type=style&index=0&id=3b0cc6e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0cc6e2",
  null
  
)

export default component.exports